const ArsSelfAffairCart = (() => {
  const wrapperSelector  = '.ars-self-affair-cart-message';
  const toastId          = 'ArsSelfAffairCartToast';
  const exclToastId      = 'ArsSelfAffairExclusionToast';

  let lastMessageKey    = null;
  let lastExcludedCount = null;
  let toastTimer        = null;
  let exclToastTimer    = null;
  let observer          = null;
  let sawInitialMutation = false;

  /* ── Leitura do card ─────────────────────────── */
  function getCardData() {
    const card = document.querySelector(wrapperSelector);
    if (!card) return null;
    return {
      eligibleCount  : parseInt(card.dataset.eligibleCount  || '0'),
      excludedCount  : parseInt(card.dataset.excludedCount  || '0'),
      title          : card.dataset.messageTitle   || '',
      toastTitle     : card.dataset.messageToastTitle || '',
      text           : card.dataset.messageText    || '',
      subtext        : card.dataset.messageSubtext || '',
      status         : card.dataset.messageStatus  || '',
      exclTitle      : card.dataset.exclusionTitle   || '',
      exclText       : card.dataset.exclusionText    || '',
      exclSubtext    : card.dataset.exclusionSubtext || '',
    };
  }

  /* ── Toast de progresso (original) ───────────── */
  function createToast() {
    let t = document.getElementById(toastId);
    if (t) return t;
    t = document.createElement('aside');
    t.id = toastId;
    t.className = 'ars-self-affair-toast';
    t.setAttribute('aria-live', 'polite');
    t.setAttribute('aria-atomic', 'true');
    t.innerHTML = `
      <div class="ars-self-affair-toast__inner">
        <div class="ars-self-affair-toast__header">
          <h2 class="ars-self-affair-toast__title"></h2>
          <button type="button" class="ars-self-affair-toast__close" aria-label="Fechar">×</button>
        </div>
        <p class="ars-self-affair-toast__text"></p>
        <p class="ars-self-affair-toast__subtext"></p>
      </div>`;
    t.querySelector('.ars-self-affair-toast__close').addEventListener('click', hideToast);
    document.body.appendChild(t);
    return t;
  }

  function updateToastContent(data) {
    const t = createToast();
    t.querySelector('.ars-self-affair-toast__title').textContent = data.toastTitle || data.title;
    t.querySelector('.ars-self-affair-toast__text').textContent  = data.text;
    const sub = t.querySelector('.ars-self-affair-toast__subtext');
    sub.textContent   = data.subtext || '';
    sub.style.display = data.subtext ? 'block' : 'none';
  }

  function getMessageKey(data) {
    return [data.title, data.toastTitle || data.title, data.text, data.subtext, data.status].join('|');
  }

  function showToast(data) {
    if (!data || !data.title) return;
    const key = getMessageKey(data);
    if (key === lastMessageKey) return;
    lastMessageKey = key;
    updateToastContent(data);
    createToast().classList.add('ars-self-affair-toast--visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4500);
  }

  function hideToast() {
    const t = document.getElementById(toastId);
    if (t) t.classList.remove('ars-self-affair-toast--visible');
  }

  /* ── Toast de exclusão (novo) ────────────────── */
  function createExclusionToast() {
    let t = document.getElementById(exclToastId);
    if (t) return t;
    t = document.createElement('aside');
    t.id = exclToastId;
    t.className = 'ars-self-affair-excl-toast';
    t.setAttribute('aria-live', 'polite');
    t.setAttribute('aria-atomic', 'true');
    t.innerHTML = `
      <div class="ars-self-affair-excl-toast__inner">
        <div class="ars-self-affair-excl-toast__header">
          <h2 class="ars-self-affair-excl-toast__title"></h2>
          <button type="button" class="ars-self-affair-excl-toast__close" aria-label="Fechar">×</button>
        </div>
        <p class="ars-self-affair-excl-toast__text"></p>
        <p class="ars-self-affair-excl-toast__subtext"></p>
      </div>`;
    t.querySelector('.ars-self-affair-excl-toast__close').addEventListener('click', hideExclusionToast);
    document.body.appendChild(t);
    return t;
  }

  function updateExclusionToastContent(data) {
    const t = createExclusionToast();
    t.querySelector('.ars-self-affair-excl-toast__title').textContent = data.exclTitle;
    t.querySelector('.ars-self-affair-excl-toast__text').textContent  = data.exclText;
    const sub = t.querySelector('.ars-self-affair-excl-toast__subtext');
    sub.textContent   = data.exclSubtext || '';
    sub.style.display = data.exclSubtext ? 'block' : 'none';
  }

  function showExclusionToast(data) {
    if (!data || !data.exclTitle) return;
    updateExclusionToastContent(data);
    createExclusionToast().classList.add('ars-self-affair-excl-toast--visible');
    if (exclToastTimer) clearTimeout(exclToastTimer);
    exclToastTimer = setTimeout(hideExclusionToast, 5000);
  }

  function hideExclusionToast() {
    const t = document.getElementById(exclToastId);
    if (t) t.classList.remove('ars-self-affair-excl-toast--visible');
  }

  /* ── Lógica principal ────────────────────────── */
  function handleCartUpdate() {
    const data = getCardData();
    if (!data) return;

    const excludedIncreased = lastExcludedCount !== null && data.excludedCount > lastExcludedCount;
    lastExcludedCount = data.excludedCount;

    if (excludedIncreased) {
      hideToast();
      showExclusionToast(data);
    } else {
      hideExclusionToast();
      showToast(data);
    }
  }

  function attachPubSub() {
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS?.cartUpdate) return false;
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    return true;
  }

  function attachObserver() {
    const target = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!target || typeof MutationObserver !== 'function') return false;
    observer = new MutationObserver(() => {
      if (!sawInitialMutation) return;
      handleCartUpdate();
    });
    observer.observe(target, { childList: true, subtree: true });
    return true;
  }

  /* ── Sidebar layout — detecta abertura do drawer ── */
  function initSidebarLayout() {
    const config = document.getElementById('ars-sa-card-config');
    if (!config || config.dataset.desktopLayout !== 'sidebar') return;

    const card  = document.querySelector(wrapperSelector);
    const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!card || !drawer) return;

    function syncSidebar() {
      const ariaHidden = drawer.getAttribute('aria-hidden');
      const isOpen = ariaHidden === 'false' ||
                     drawer.classList.contains('active') ||
                     drawer.classList.contains('is-open') ||
                     drawer.hasAttribute('open');
      card.classList.toggle('ars-sa-sidebar-active', isOpen);
    }

    new MutationObserver(syncSidebar).observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'open', 'style']
    });

    // Fallback: detecta cliques no ícone do carrinho
    document.addEventListener('click', (e) => {
      if (e.target.closest('[href*="/cart"], [data-cart], .cart-count-bubble, cart-icon-bubble')) {
        setTimeout(syncSidebar, 150);
      }
    });

    syncSidebar();
  }

  function init() {
    createToast();
    createExclusionToast();

    const initialData = getCardData();
    lastExcludedCount = initialData ? initialData.excludedCount : 0;

    attachPubSub();
    attachObserver();
    initSidebarLayout();
    setTimeout(() => { sawInitialMutation = true; }, 300);
  }

  document.addEventListener('DOMContentLoaded', init);

  return { showToast, hideToast, showExclusionToast, hideExclusionToast };
})();
